import { connect, MapStateToProps } from 'react-redux'
import RecommendationsComponent, { Props } from './RecommendationsComponent'
import vwnRecommendationsForModelDataSelector from '../../redux/selectors/recommendations/vwnRecommendationsForModelDataSelector'
import { selectEquipment } from '../../redux/actions/app/equipmentGroups.actions'
import { openInfoModal } from '../../redux/actions/app/infoModal.actions'
import { trackVwnRecommendedEquipments } from '../../redux/actions/app/vwnRecommendation.actions'

type StateProps = Pick<
    Props,
    'recommendationsData'
>

type DispatchProps = Pick<Props, 'selectEquipment' | 'openInfoModal' | 'trackRecommendedEquipments'>

const mapDispatchToProps: DispatchProps = {
    selectEquipment,
    openInfoModal,
    trackRecommendedEquipments: trackVwnRecommendedEquipments,
}

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    recommendationsData: vwnRecommendationsForModelDataSelector(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(RecommendationsComponent)
